import React from "react";
import "./ContinueButton.css"; // CSS dédié au bouton
import { ArrowRightOutlined } from '@ant-design/icons';

const ContinueButton = ({ disabled, onClick, children = "Continue"}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ContinueButton;
